
const questions = {
    "reportGuid": null,
    "categories": [
        {
            "categoryName": "God",
            "categoryDescription": "Personal relationship with God",
            "data": [
                {
                    "name": "Consistency in satisfying personal devotions",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Consistency in satisfying Prayer",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Consistency in satisfying Bible reading",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Consistency in satisfying Bible memorization",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Satisfying corporate worship",
                    "description": "Heart engaged in singing and responsive to the Word",
                    "answer": null,
                    "answerType": 2
                }
            ]
        },
        {
            "categoryName": "Family",
            "categoryDescription": "Family relationships and sexual integrity",
            "data": [
                {
                    "name": "Family joy and harmony",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Family worship",
                    "description": "e.g., prayer, Bible reading/study, reading a Christian book, discussions, etc.",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Have I given appropriate time and attention to my family?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I intentionally discipled my family this week?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I spoken harshly in anger/frustration to my wife and/or children this week?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I disciplined my child in anger this week?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I sought or intentionally looked at sexually explicit material?",
                    "description": "Searched for and/or viewed videos or pictures for the purpose of gratifying sexual desire",
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I had any one on one conversations with a woman other than my wife, whether in person, text, email, messages of any sort?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I dwelt on and/or entertained sexual thoughts about a woman?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I stimulated myself sexually?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I drunk alcohol in any amounts this week?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I taken any other types of substances this week, whether prescribed or otherwise?",
                    "description": "Marijuana/THC (in any form), pain medications, barbiturates, benzodiazepines, or any substances considered illegal in the state of Colorado?",
                    "answer": null,
                    "answerType": 3
                }
            ]
        },
        {
            "categoryName": "Others",
            "categoryDescription": null,
            "data": [
                {
                    "name": "Have I used my time and energy to bless others this week in some way?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I shared the gospel with anyone this week?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I interacted with others and fulfilled my obligations with honesty and integrity?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I lied to anyone about anything this week?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I had any moments of anger or frustration that caused me to speak harshly or wrongly to another person?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                }
            ]
        },
        {
            "categoryName": "Health",
            "categoryDescription": "Stewardship of your body",
            "data": [
                {
                    "name": "Eating (Quality and Quantity)",
                    "description": "1 = not enough, 3 = just right, 5 = too much",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Exercise",
                    "description": "1 = too little, 3 = just right, 5 = too much",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Sleep",
                    "description": "1 = too little, 3 = just right, 5 = too much",
                    "answer": null,
                    "answerType": 2
                }
            ]
        },
        {
            "categoryName": "Time",
            "categoryDescription": null,
            "data": [
                {
                    "name": "Have I managed my time spent on the internet well?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I spent too much time on entertainment and recreation",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                }
            ]
        },
        {
            "categoryName": "Pastoral Leadership",
            "categoryDescription": null, 
            "data": [
                {
                    "name": "Have I prayed every day for people in your pastoral care?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Is there anything that is hindering me from following up with someone in your care, due to fear of conflict or confrontation?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I had people over at my house for fellowship?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Are there any theological questions/ideas I am currently wrestling over or confused about?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Are there situations/questions with people in the body that I need the additional wisdom of the Elders to help me address or speak into to?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                }
            ]
        },
        {
            "categoryName": "Finances",
            "categoryDescription": null,
            "data": [
                {
                    "name": "Have I been disciplined in my budgeting and spending?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I been transparent with my spending with my wife?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Have I held back from giving money to others when needs arose?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                }
            ]
        },
        {
            "categoryName": "Sin",
            "categoryDescription": "Addressing specific temptations",
            "data": [
                {
                    "name": "Anger",
                    "description": "Have I experienced annoyance, frustration or anger leading to me speaking or acting out in anger?",
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Anxiety",
                    "description": "Have I experienced an uneasiness of mind, worry, or fear that I’ve struggled with overcoming?",
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Bitterness",
                    "description": "Am I holding any grudges, unforgiveness, or bitterness towards another person?",
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Covetousness/idolatry",
                    "description": "Has anything distracted me from seeking first God’s Kingdom?",
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Discouragement/Depression",
                    "description": "Have I experienced a loss of hope due to some discouragement and/or depression?",
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Joylessness",
                    "description": "Have I been failing to delight in God as my supreme treasure?",
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Laziness",
                    "description": "Have I been unwilling to work hard when I don’t feel like working?",
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Perfectionism",
                    "description": "Have I refused to accept any standard short of my own notion of perfection?",
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Pride",
                    "description": "Have I held a high opinion of my self importance; and has that produced an attitude of superiority over others in me in any way?",
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Selfishness",
                    "description": "Have I put myself first instead of others due to my heart being selfish?",
                    "answer": null,
                    "answerType": 3
                }
            ]
        },
        {
            "categoryName": "Summary",
            "categoryDescription": "Last comments",
            "data": [
                {
                    "name": "Comments",
                    "description": "Prayer requests, accountability needs, praises, confessions, explanations, etc.",
                    "answer": null,
                    "answerType": 1
                }
            ]
        }
    ]
}

module.exports = questions;